"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Badge-Widget. Kann in anderen Widgets über die Option <code>badge</code>
 * hinzugefügt werden.
 *
 * @example <caption>Einbindung in ein anderes Widget und Update durch Listener:</caption>
 * var myWidget = new gc.gis.widget.GCItem({
 *     label: 'Foo',
 *     click: function( evt ) {
 *         // do something
 *     },
 *     badge: new gc.gis.widget.GCBadge({
 *         init: function() {
 *             var b = this; // Achtung: this === GCBadge-Instanz
 *             gc.gis.iface.modules.MyModule.on('my:module:event', self, function( evt ) {
 *                 b.update();
 *             })
 *         },
 *         update: function() {
 *             this.clear();
 *             var count = gc.gis.iface.modules.MyModule.getCount();
 *             if( count > 0 )
 *             {
 *                 // Badge-Inhalt setzen
 *                 this.element.html(
 *                     '<span class="gc-badge-value">'+ count +'</span>'
 *                     +' <span class="gc-badge-unit">'+ (count>1?'Elemente':'Element') +'</span>');
 *                 this.element.removeClass('gc-empty gc-hidden');
 *             }
 *             else
 *             {
 *                 // Badge verstecken, wenn leer
 *                 this.element.addClass('gc-empty gc-hidden');
 *             }
 *         }
 *     })
 * });
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {function} options.init
 * @param {function} options.update
 */
gc.gis.widget.GCBadge = function( options )
{
	gc.gis.widget.GCWidget.call( this, options );

	this.init_callback = options.init;
	this.update_callback = options.update;

	this._render();

	this.init_callback.call(this);
};
gc.gis.widget.GCBadge.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @inheritdoc
 */
gc.gis.widget.GCBadge.prototype._render = function()
{
	if( !this.element )
	{
		this.element = jQuery('<span>', {
			'class': 'gc-badge badge'+ (self.className ? ' '+ self.className : '')
		});
	}
	return this.element;
};

/**
 * Leert das Container-Element.
 *
 * @public
 * @method
 */
gc.gis.widget.GCBadge.prototype.clear = function()
{
	this.element.children().remove();
};

/**
 * Aufruf der Update-Callback {@link gc.gis.widget.GCBadge.update_callback}.
 *
 * @public
 * @method
 */
gc.gis.widget.GCBadge.prototype.update = function()
{
	this.update_callback.call( this );
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCBadge.prototype.getElement = function()
{
	return this.element;
};

